import React, { useContext, useEffect, useState } from 'react';
import { AssessmentContext } from '../context/AssessmentContext';
import '../styles/Table.css';

const QuestionsTab = ({ assessmentId }) => {
  const {
    assessment,
    deleteQuestion,
    loading,
    saveQuestion,
    question,
    selectQuestion,
  } = useContext(AssessmentContext);

  const [criteriaId, setCriteriaId] = useState('');
  const [mode, setMode] = useState('list');
  const [name, setName] = useState('');
  const [order, setOrder] = useState(0);
  const [sectionCode, setSectionCode] = useState('');

  useEffect(() => {
    assessment.sections.forEach((section) => {
      if (!section.questions) {
        section.questions = [];
      }
    });
  }, [assessment]);

  const handleCancel = () => {
    setMode('list'); 
  }

  const handleNew = () => {
    setName('');
    //setSectionCode('');
    if (assessment.criteria.length === 1) {
      setCriteriaId(assessment.criteria[0].id);
    } else {
      setCriteriaId('');
    }    
    setOrder(0);
    selectQuestion(null);
    setMode('edit');
  }

  const handleEditQuestion = async (questionId) => {
    selectQuestion(questionId);
    setName(question.name);
    setSectionCode(question.sectionCode);
    setCriteriaId(question.criteriaId);
    setOrder(question.order);
    setMode('edit');
  }

  const handleSaveQuestion = async () => {
    question.name = name;
    question.sectionCode = sectionCode;
    question.criteriaId = criteriaId;
    question.order = order;
    if (order === 0) {
      question.order = assessment.sections.find(s => s.code === sectionCode).questions.length + 1;
    }
    await saveQuestion(question);
    handleNew();
  }

  if (loading) {
    return <div>Cargando datos...</div>;
  }

  return (
    <div>
      {mode === 'list' && (
        <>
          <button onClick={() => handleNew() }>
            <span role="img" aria-label="add">➕</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      {mode === 'edit' && (
        <>
          <button onClick={() => handleCancel() }>
            <span role="img" aria-label="cancel">❌</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      {mode === 'list' && (
        <table>
          <thead>
            <tr>
              <th>No.</th>
              <th>Pregunta</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {assessment.sections.map((section, sectionIndex) => (
              <React.Fragment key={sectionIndex}>
                <tr>
                  <td colSpan="4" style={{ fontWeight: 'bold' }}>{section.name}</td>
                </tr>
                {section.questions.map((question, questionIndex) => (
                  <tr key={questionIndex}>
                    <td>{question.order}</td>
                    <td>{question.name}</td>
                    <td>
                      <button onClick={() => handleEditQuestion(question.id)}>
                        <span role="img" aria-label="edit">✏️</span>
                      </button>
                      <button onClick={() => deleteQuestion(question.id)}>
                        <span role="img" aria-label="delete">🗑️</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
      {mode === 'edit' && (
        <div className="data-form">
          <div>
            <select
              value={sectionCode}
              onChange={(e) => setSectionCode(e.target.value)}
            >
              <option value="">Seleccione una sección</option>
              {assessment.sections.map((section, index) => (
                <option key={index} value={section.code}>
                  {section.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value) }
              placeholder='Texto de la pregunta'
            />
          </div>
          <div>
            <select
              value={criteriaId}
              onChange={(e) => setCriteriaId(e.target.value)}
            >
              <option value="">Seleccione el criterio</option>
              {assessment.criteria.map((criterion, index) => (
                <option key={index} value={criterion.id}>
                  {criterion.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <input
              type="number"
              value={order}
              onChange={(e) => setOrder(e.target.value) }
              placeholder='Orden'
            />
          </div>
          <br/>
          <button onClick={() => handleSaveQuestion() }>
            Grabar
          </button>
        </div>
      )}
    </div>
  );
};

export default QuestionsTab;
